import userStore from 'entities/user/module/user-store'

import { DEV_PHONE_NUMBERS } from 'shared/constants'

export const getUserIsDevelopers = () => {
  return DEV_PHONE_NUMBERS.includes(userStore.account?.phone_number || '')
}
